import { Button, Header as HeaderComponent } from "frno-react";
import useLayoutStore, { Layout } from "../state/LayoutStore";

export default function Header() {
  useLayoutStore();

  const { layout }: { layout: Layout } = useLayoutStore();

  return (
    <HeaderComponent
      logo="https://www.forbrukerradet.no/wp-content/themes/frweb22/dist/forbrukerradet_logo.svg"
      logoSmall="https://www.forbrukerradet.no/wp-content/themes/frweb22/dist/forbrukerradet_logo_symbol.svg"
      expandableMenuColumns={layout.nav?.mega_menu}
      homeLink={"https://www.forbrukerradet.no/"}
    >
      {layout.nav?.container.map((item, i) => (
        <Button
          key={i}
          href={item.url}
          className={`${item.classList ?? ""} button-default`}
        >
          {item.title}
        </Button>
      ))}
    </HeaderComponent>
  );
}
